import { createFileRoute } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { HomeSellFlow } from "@/components/home/HomeSellFlow";
import { latestAdsQueryOptions } from "@/lib/latest-ads";

export const Route = createFileRoute("/es/")({
  head: () => ({
    meta: [
      { title: "Vende tus cosas – anuncio gratis en un minuto | Sellavo" },
      {
        name: "description",
        content: "Vende artículos de segunda mano rápidamente. Haz una foto, recibe un anuncio y precio sugerido, y publica gratis en Sellavo.",
      },
      { property: "og:title", content: "Vende tus cosas – anuncio gratis en un minuto | Sellavo" },
      {
        property: "og:description",
        content: "Haz una foto, recibe un anuncio y precio sugerido, y publica gratis tu artículo de segunda mano.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es" }],
  }),
  loader: ({ context }: { context: { queryClient: QueryClient } }) => {
    void context.queryClient.prefetchQuery(latestAdsQueryOptions());
  },
  component: SpanishHomePage,
});

function SpanishHomePage() {
  return <HomeSellFlow />;
}